import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
   <svg
    id="Layer_2_00000001638482815544227280000012265198943943796149_"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 15 201.7 127"
    style={{
      enableBackground: "new 0 15 201.7 127",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        `\n\t.rear_st0{fill:none;stroke:${strokeColor};stroke-width:1;stroke-miterlimit:10;}\n`
      }
    </style>
    <g>
      <path
        className="rear_st0"
        d="M27,117.4l0.1,19.3c0,0-0.4,0.5,1.6,1.4s17.3,0,17.3,0s1.1-0.5,0.9-2.1c-0.1-1.4-0.1-2.5-0.1-5.8"
      />
      <path
        className="rear_st0"
        d="M170.4,117.1l-0.1,20.6c0,0,0,1.5-0.5,1.7c-2.3,0.7-20.2,0.3-20.2,0.3s-0.7,0.2-0.7-1.7c0-1.4-0.1-5.4-0.1-7.9 c0,0,6.6-0.3,6.8-0.4l2.7-0.3c6.4-0.9,7.7-3,9.2-5.2C169.2,121.3,170.4,116.9,170.4,117.1z"
      />
      <g>
        <path
          className="rear_st0"
          d="M152.9,20.5c1.4,3.7,7.3,24.6,8.7,29.7c1.6,5.8,8.2,17.4,8.8,23.2l0,0c0,0,4.4,7.1,4.4,15.2 s-2.5,31.1-9.5,38.1c-2.3,2.3-8.2,3.3-16.1,3.3H49c-2.8-0.3-5.2,0.5-8.3-0.2c-6.9-1.4-9.3-4.3-9.7-4.7c-6.9-7.5-7.6-29.1-7.6-36.5 c0-4.9,1.4-9.4,2.5-12.2c0.7-1.8,1.3-3,1.3-3c0.6-5.7,4.8-19.1,5.8-24.6c1-5.6,6.9-23.1,7.8-26.9c0.2-0.9,0.6-2.3,1.1-3.8"
        />
      </g>
      <path className="rear_st0" d="M43.1,150.8" />
      <path
        className="rear_st0"
        d="M47.6,18.1c-1.4,6.1-4.1,19-4.9,26.8c-1,10.3-1.3,14.6,2.8,15.8c4.1,1.1,101,0,101,0s3.4,0.3,4.9-3.4 c1.4-3.4-0.3-21.7-3.9-36.9"
      />
      <path
        className="rear_st0"
        d="M40,72.6c-0.5,6.4-0.3,6.8-0.2,13.9l0.4,23.6c0.1,4.1,3.4,7.4,7.5,7.4h103c4.1,0,7.4-3.3,7.4-7.4V81"
      />
      <g>
        <path
          className="rear_st0"
          d="M40,72.1c0,0-7-1.2-9.6,5s-2.2,13.4-1.9,15.3s1.3,2.8,4.2,3.1s7.3,0.4,7.3,0.4V72.1L40,72.1z"
        />
      </g>
      <g>
        <path
          className="rear_st0"
          d="M158.1,72.1c0,0,7-1.2,9.6,5s2.1,14.4,1.8,16.3s-1.8,2.2-4.7,2.5c-2.8,0.2-6.8,0.5-6.8,0.5L158.1,72.1 L158.1,72.1z"
        />
      </g>
      <rect x={82.5} y={121.7} className="rear_st0" width={35.1} height={8.4} />
    </g>
  </svg>
);
export default SvgComponent;